import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-link',
  imports: [],
  templateUrl: './link.component.html',
})
export class LinkComponent {
  @Input({ required: true }) description: string;
  @Input() href?: string;
  @Input() cssClass?: string = 'outline-none';
  @Input() clickAction?: () => void;

  onClick(event: Event) {
    if (!this.href) {
      event.preventDefault();
      this.clickAction?.();
    }
  }
}
